module.exports = __webpack_public_path__ + "static/media/xaki-dantela-writer.0cd367f8.jpg";